import * as React from 'react';
import * as reactIs from 'react-is';

export function deepChildrenMap<T>(
  children: React.ReactNode,
  callback: (child: React.ReactNode, offset: number) => T,
): Array<T> {
  let offset = 0;
  function mapper(children: React.ReactNode): Array<T> {
    const output: Array<T> = [];
    React.Children.forEach(children, child => {
      if (child === false || child == null) {
        return;
      }
      if (Array.isArray(child)) {
        output.push(...mapper(child));
        return;
      }
      if (reactIs.isFragment(child)) {
        output.push(...mapper(child.props.children));
        return;
      }
      if (reactIs.isPortal(child)) {
        output.push(...mapper(child.props.children));
        return;
      }
      output.push(callback(child, offset));
      offset += 1;
    });
    return output;
  }
  return mapper(children);
}
